import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const COLS = [
  {
    title: "Platform",
    links: [
      { to: "/technology", label: "Technology" },
      { to: "/solutions", label: "Solutions" },
      { to: "/security", label: "Security" },
    ],
  },
  {
    title: "Trust",
    links: [
      { to: "/trust-centre", label: "Trust Centre" },
      { to: "/privacy", label: "Privacy Notice" },
      { to: "/cookies", label: "Cookie Policy" },
      { to: "/terms", label: "Terms of Use" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/company", label: "About" },
      { to: "/insights", label: "Insights" },
      { to: "/faq", label: "FAQ" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Resources",
    links: [
      { to: "/contact", label: "Request a Demo" },
      { to: "/contact", label: "Speak to the Team" },
      { to: "/insights", label: "Press" },
    ],
  },
];

export const Footer = () => (
  <footer className="border-t border-[#06102A]/10 bg-[#FAFBFC]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-8 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-4">
        <Logo className="h-8 w-auto" />
        <p className="mt-6 text-sm text-[#06102A]/70 max-w-sm leading-relaxed">
          Identity-bound custody infrastructure for banks, institutions and the future of digital
          ownership.
        </p>
        <p className="mt-8 text-xs uppercase tracking-[0.22em] text-[#06102A]/50">
          The Trust Layer for Regulated Digital Finance
        </p>
      </div>

      {COLS.map((c) => (
        <div className="md:col-span-2" key={c.title}>
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#06102A]">
            {c.title}
          </p>
          <ul className="mt-5 space-y-3">
            {c.links.map((l) => (
              <li key={l.label}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-[#06102A]/70 hover:text-[#06102A] transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>

    <div className="border-t border-[#06102A]/10">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <p className="text-xs text-[#06102A]/55">
          © {new Date().getFullYear()} Vaultavo. All rights reserved.
        </p>
        <p className="text-xs text-[#06102A]/55 font-mono-vt">
          U.S. patents pending · Built for regulated digital finance
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
